import FormField from "@components/Form/FormFields/FormFields";
import FormErrorMessage from "@components/FormErrorMessage/FormErrorMessage";
import ApiError from "@components/GenericApiError/Error";
import Grid from "@components/Grid/Grid";
import { IsLoggedIn } from "@components/GuestView/IsLoggedIn";
import { useSettings } from "@utilities/context/settings";
import getCookie from "@utilities/getCookie";
import { handleSubmitFormErrors } from "@utilities/handleSubmitFormErrors";
import { logoutUser } from "@utilities/navigation";
import { useContext, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { changeEmail, getPersonalDetails } from "services/forms";
import { CHANGEEMAILNOTIFICATION_URL } from "../../constants";
import { UserContext } from "../../context/user";
import styles from "./C67_ChangeEmail.module.scss";

export interface ChangeEmailProps {
  title: string;
  introText: string;
  currentEmailText: string;
  newEmailLabel: string;
  confirmEmailLabel: string;
  submitText: string;
  successPage: {
    fields: {
      slug: string;
    };
  };
}

export const C67_ChangeEmail = (props: { content: ChangeEmailProps }) => {
  const { apiErrorMessages } = useSettings();
  const [handledSubmitFormErrors, setHandledSubmitFormErrors] =
    useState<Array<string> | null>(null);
  const { content } = props;
  const {
    title,
    introText,
    currentEmailText,
    newEmailLabel,
    confirmEmailLabel,
    submitText,
    successPage,
  } = content;
  const { user } = useContext(UserContext);

  const [userEmail, setUserEmail] = useState<any>(null);
  const [error, setError] = useState<boolean>(false);

  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm({
    mode: "onBlur",
  });

  useEffect(() => {
    const getEmail = async () => {
      if (user) {
        try {
          setUserEmail(user["userData"]["email"]);
        } catch (e) {
          console.log(e);
          setError(true);
        }
      }
    };
    getEmail();
  }, [user]);

  const onSubmit = async (data) => {
    try {
      const accessToken = getCookie("access_token");
      setHandledSubmitFormErrors(null);
      if (accessToken && data?.email) {
        const response = await changeEmail(accessToken, data?.email);
        if (response?.status === 200) {
          const details = await getPersonalDetails();
          const emailData = {
            firstName: details?.result?.firstName || "",
            emailAddress: userEmail,
          };
          await handleSendingEmail(emailData);
          logoutUser(successPage?.fields?.slug);
        } else {
          const handledSubmitFormErrors = handleSubmitFormErrors(
            response,
            apiErrorMessages
          );
          window.scrollTo(0, 0);
          setHandledSubmitFormErrors(handledSubmitFormErrors);
        }
      }
    } catch (e) {
      console.log("error", e);
    }
  };

  const handleSendingEmail = async (data) => {
    try {
      await fetch(CHANGEEMAILNOTIFICATION_URL, {
        method: "POST",
        body: JSON.stringify({
          firstName: data.firstName,
          emailAddress: data.emailAddress,
        }),
      });
    } catch (_e) {
      // handled server-side via retry + Application Insights logging
    }
  };

  if (error) {
    return <ApiError />;
  }

  return (
    <div className="wrapper">
      <Grid row></Grid>
      <Grid column md={12} sm={12}>
        <div className={styles["change-email"]}>
          <div className={styles.coont}>
            <h1>{title}</h1>
            {handledSubmitFormErrors &&
              handledSubmitFormErrors.map((error, index) => (
                <FormErrorMessage
                  key={index}
                  text={error}
                  userEmail={userEmail}
                />
              ))}
            <p>{introText}</p>
            <p>
              <b>{currentEmailText}: </b>
              {userEmail}
            </p>
            <form method="POST" className="form" onSubmit={handleSubmit(onSubmit)}>
              <FormField
                formType="input"
                watch={watch}
                validation={{
                  isRequired: true,
                  email: true,
                  maxLength: 255,
                }}
                type="email"
                register={register}
                key={`${newEmailLabel}`}
                placeholder={newEmailLabel}
                name="email"
                errors={errors}
              />
              <FormField
                formType="input"
                watch={watch}
                validation={{
                  isRequired: true,
                  email: true,
                  confirmEmail: true,
                  maxLength: 255,
                }}
                type="email"
                register={register}
                key={`${confirmEmailLabel}`}
                placeholder={confirmEmailLabel}
                name="confirmEmail"
                errors={errors}
              />
              <div className="row"></div>
              <div className="button-wrapper">
                <input
                  type="submit"
                  id="ConfirmButton"
                  value={submitText}
                  className="cta primary"
                  disabled={!userEmail}
                />
              </div>
            </form>
          </div>
        </div>
      </Grid>
    </div>
  );
};

export default IsLoggedIn(C67_ChangeEmail);
